import { useMutation } from "react-query";
import { postDecryptToken } from "./postDecryptToken";
import { TDecryptToken, TDecryptTokenBody } from "./types";

export const useDecryptToken = () => {
  return useMutation<TDecryptToken, unknown, TDecryptTokenBody>((payload) =>
    postDecryptToken(payload)
  );
};
